var _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgECommerce(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "231 231 50 50",
    enableBackground: "new 231 231 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#01C28D",
    d: "M273.849,246.964c-0.057-0.944-0.84-1.68-1.786-1.679h-7.143v-5.357c0-4.931-3.997-8.929-8.929-8.929 c-4.931,0-8.929,3.998-8.929,8.929v5.357h-7.143c-0.946-0.001-1.729,0.734-1.786,1.679l-1.572,28.375 c-0.167,2.954,2.091,5.485,5.045,5.652c0.104,0.006,0.208,0.009,0.312,0.009h28.16c2.959,0.005,5.361-2.39,5.366-5.349 c0-0.104-0.003-0.208-0.009-0.313L273.849,246.964z M250.634,239.929c0-2.959,2.398-5.357,5.357-5.357 c2.959,0,5.357,2.398,5.357,5.357v5.357h-10.714V239.929z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 231,
    fill: "none",
    width: 50,
    height: 50
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgECommerce);
export default __webpack_public_path__ + "static/media/E-commerce.9eb0573adc565a3e8c54fac727989287.svg";
export { ForwardRef as ReactComponent };